<template>
  <div class="switch_container">
    <div class="switch">
      <div class="switch_text"
           :class="{
            'switch_text__active': isFirstSwitchActive,
           }"
           @click="changeSwitch(true)"
      >
        <div class="text text__desktop">{{ firstName }}</div>
        <div class="text text__mobile">{{ firstNameMobile }}</div>
      </div>
    </div>

    <div class="switch_block">
      <input type="checkbox"
             class="switch_1"
             v-model="isFirstSwitchActive"
      >
    </div>

    <div class="switch">
      <div class="switch_text"
           :class="{
            'switch_text__active': !isFirstSwitchActive,
           }"
           @click="changeSwitch(false)"
      >
        <div class="text text__desktop">{{ secondName }}</div>
        <div class="text text__mobile">{{ secondNameMobile }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SwitchComponent",

  props: {
    firstName: { // наименование 1 switch
      type: String,
      default: () => {
        return ''
      }
    },

    secondName: { // наименование 2 switch
      type: String,
      default: () => {
        return ''
      }
    },

    firstNameMobile: { // наименование 1 switch для моб. устройств
      type: String,
      default: () => {
        return ''
      }
    },

    secondNameMobile: { // наименование 2 switch для моб. устройств
      type: String,
      default: () => {
        return ''
      }
    },

    firstSwitchActive: { // активен первый switch?
      type: Boolean,
      default: () => {
        return false
      }
    }
  },

  data() {
    return {

    }
  },

  created() {

  },

  mounted() {

  },

  watch: {

  },

  methods: {
    /** Установить тип репетитора
     * @param {Boolean} isFirstsSelected - выбран первый элемент?
     * */
    changeSwitch(isFirstsSelected) {
      this.$emit('changeSwitch', isFirstsSelected);
    },
  },

  computed: {
    isFirstSwitchActive: { // активен первый switch?
      get() {
        return this.firstSwitchActive
      },

      set(modelValue) {
        this.$emit('update:firstSwitchActive', modelValue);
      },
    }
  },

  components: {

  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../style/variables";

.switch_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .text__desktop {
    display: flex;
  }

  .text__mobile {
    display: none;
  }
}

.switch {
  display: flex;
  flex-direction: row;
  align-items: center;

  .module_help__theme_tutors {
    margin-left: 5px;
  }
}

.switch_text {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: $color_cyanite_2;
  transition: $transition_medium;
  min-width: 80px;
  cursor: pointer;

  &:hover {
    color: $color_purple_3;
  }
}

.switch_text__active {
  color: $color_purple_3;
}

.switch_text__first {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.switch_text__second {
  justify-content: flex-start;
}

.switch_block {
  margin: 0 14px;

  input[type="checkbox"].switch_1{
    font-size: 30px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 44px;
    height: 24px;
    border: 1px solid $color_cyanite_bg_1;
    background: rgba(255, 255, 255, 0);
    border-radius: 20px;
    position: relative;
    cursor: pointer;
    outline: none;
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  input[type="checkbox"].switch_1:checked{
    background: rgba(51, 51, 51, 0);
  }

  input[type="checkbox"].switch_1:after{
    position: absolute;
    content: "";
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: $color_purple_3;
    left: calc(100% - 18px - 3px);
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
  }

  input[type="checkbox"].switch_1:checked:after{
    left: 3px;
  }
}

@media all and (max-width: 1600px) {

}

@media all and (max-width: 1440px) {
  .switch_text {
    font-size: 15px;
    line-height: 19px;
    min-width: 75px;
  }

  .switch_block input[type="checkbox"].switch_1 {
    width: 42px;
    height: 22px;
    border-radius: 20px;
  }

  .switch_block input[type="checkbox"].switch_1:after {
    width: 16px;
    height: 16px;
    left: calc(100% - 16px - 3px);
  }

  .switch_block input[type="checkbox"].switch_1:checked:after{
    left: 3px;
  }
}

@media all and (max-width: 1280px) {

}

// tablet
@media all and (max-width: 1160px) {

}

@media all and (max-width: 960px) {

}

// mobile
@media all and (max-width: 600px) {
  .switch_container {
    display: flex;
    width: 100%;
    height: 48px;
    border-radius: 8px;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.08);

    .text__desktop {
      display: none;
    }

    .text__mobile {
      display: flex;
    }
  }

  .switch_text {
    font-size: 14px;
    line-height: 18px;
    min-width: auto;
  }

  .switch_block {
    margin: 0 9px;
  }

  .switch_block input[type="checkbox"].switch_1:after {
    width: 14px;
    height: 14px;
    left: calc(100% - 14px - 3px);
  }

  .switch_block input[type="checkbox"].switch_1:checked:after {
    left: 3px;
  }

  .switch_block input[type="checkbox"].switch_1 {
    width: 38px;
    height: 20px;
    border-radius: 20px;
  }
}
</style>